export const RADIO_TRUE = 'true';
export const RADIO_FALSE = 'false';

export const DISCOUNTED = 'discounted';
export const BENEFITS = 'benefits';
export const NO_RENEWALS = 'no_renewals';
export const SOLAR = 'solar';

export const EVERYDAY_REWARDS = 'everyday rewards';
export const HOME_SUPPORT = 'home support';
export const NO_REWARDS = 'no_rewards';

export const FIXED_RATE = 'fixed_rate';
export const VARIABLE_RATE = 'variable_rate';